module.exports = Vuex;


//////////////////
// WEBPACK FOOTER
// external "Vuex"
// module id = SJI6
// module chunks = 18